module.exports = __webpack_public_path__ + "img/icon运动员等级_职工四级@3x.1a0e4787.png";